import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({

    //common
    sectionTitle: {
        background: 'linear-gradient(to top, rgba(134, 230, 236, 0.7) 35%, transparent 35%)',
        lineHeight: 1.4,

        fontWeight: 500,
        maxWidth: '100%',
        fontSize: 'calc(1.875rem + ((1vw - 4.14px) * 0.9107))',
        padding: '0 .5em',
        letterSpacing: '0.02em',
    },
    sectionSubTitle: {
        lineHeight: 1.4,

        maxWidth: '100%',
        fontSize: '24px',
        color: '#333',
        letterSpacing: '0.02em',
        textAlign: 'center',
        margin: '60px 0 20px'
    },
    


    //top section
    topImage: {
        // position: 'absolute',
        width: '472px',
        height: '552.18px',
        // left: '853.39px',
        // top: '214.39px',
        background: 'radial-gradient(10438.51% 17019.45% at 37.86% 37%, rgba(255, 255, 255, 0.7) 0.71%, rgba(255, 255, 255, 0.6) 100%, rgba(255, 255, 255, 0.3) 100%)',
        // border: '2px solid #FFFFFF',
        sizing: 'border-box',
        shadow: 'inset 0px 0px 30px 2px rgba(255, 255, 255, 0.5)',
        radius: '15px',
        borderRadius: '25px',
        opacity: 0.9,
        margin: '0 auto 0 auto'
    },
    documentButton: {
        color: '#86E6EC',
        background: '#FFFFFF',
        borderRadius: '32.83px',
        border: '1px solid #86E6EC',
        // width: '240px',
        // height: '48.78px',
        padding: '12px 30px',
        marginTop: 60,
        marginRight: 25,
        filter: 'drop-shadow(2px 2px 10px rgba(51, 51, 51, 0.1))',
        fontSize: '16px',
    },
    signupButton: {
        color: 'white',
        background: '#86E6EC',
        borderRadius: '32.83px',
        marginTop: 60,
        marginRight: 25,
        padding: '12px 30px',
        fontSize: '16px',

    },
    loginButton: {
        color: 'white',
        marginTop: 60,
        background: '#86E6EC',
        border: '1px solid #F3923D',
        borderRadius: '32.83px',
        padding: '12px 30px',

    },

    smallTopTitle: {
        fontSize: '18px',
        fontWeight: 300,
    },
    smallTitle: {
        fontSize: '18px',
    },
    leftGrid: {
        textAlign: 'left'
    },
    motivationalTitle: {
        background: 'linear-gradient(to top, rgba(134, 230, 236, 0.7) 35%, transparent 35%)',
        lineHeight: 1.4,
        fontWeight: 500,
        fontSize: 'calc(3.125rem + ((1vw - 4.14px) * 0.9107))',
    },

    // partnerSection
    partnerSection: {
        margin: '100px 0',
        textAlign: 'left',
    },
    sponsorDiv: {
        width: 'auto',
        align: 'center',
        boxSizing: 'border-box',
        borderRadius: '30px',
        background: 'radial-gradient(10438.51% 17019.45% at 37.86% 37%, rgba(255, 255, 255, 0.7) 0.71%, rgba(255, 255, 255, 0.6) 100%, rgba(255, 255, 255, 0.3) 100%)',
        border: '2px solid white',
        padding: '50px 30px',
        margin: '50px 0',
    },
    sponsorLogos: {
        height: 120,
        maxWidth: 300,
        objectFit: 'contain',
    },

    //our Future Section
    ourFutureSection: {
        margin: '100px 0',
        textAlign: 'left',
    },
    ourFutureImage: {
        width: '600px',
        maxWidth: '90%',
    },

    ourFutureImageDiv: {
        width: '100%',
        textAlign: 'center',
    },

    // what flare Can Section
    flareCanSection: {
        margin: '100px 0',
        textAlign: 'left',
    },
    flareCanContainer: {
        borderRadius: '15px',
        background: 'radial-gradient(10438.51% 17019.45% at 37.86% 37%, rgba(255, 255, 255, 0.7) 0.71%, rgba(255, 255, 255, 0.6) 100%, rgba(255, 255, 255, 0.3) 100%)',
        border: '2px solid #A9EAEB',
        display: 'flex',
        justifyContent: 'space-between',
        justifyItems: 'center',
        alignItems: 'center',
        padding: '30px 30px',
        margin: '40px 0',

    },
    flareCanIconDiv: {
        display: 'flex',
        alignItems: 'center',
    },
    flareCanIcon: {
        height: '80px',
    },
    flareCanPartition: {
        width: '2px',
        height: '80px',
        background: '#A9EAEB',
        padding: '0',
        margin: '0 30px',
    },
    flareCanMainText: {
        margin: '0 20px 20px',
        fontSize: '20px',
        lineHeight: 1.5,
    },
    flareCanSubText: {
        margin: '0 20px 0',
        fontWeight: 300,
        fontSize: '16px',
        lineHeight: 1.5,
        maxWidth: '580px',

    },
    flareCanImg: {
        height: '140px',
    },
    moreWhatWeCanDiv: {
        width: '100%',
        textAlign: 'center',
    },
    // what flare Can Section Small
    flareCanContainerSmall: {
        borderRadius: '15px',
        background: 'radial-gradient(10438.51% 17019.45% at 37.86% 37%, rgba(255, 255, 255, 0.7) 0.71%, rgba(255, 255, 255, 0.6) 100%, rgba(255, 255, 255, 0.3) 100%)',
        border: '2px solid #A9EAEB',
        padding: '30px 20px',
        margin: '40px auto',
        maxWidth: '350px',
    },
    flareCanIconDivSmall: {
        display: 'flex',
        alignItems: 'center',
        margin: '30px 0 20px'
    },
    flareCanIconSmall: {
        height: '40px',
    },
    flareCanPartitionSmall: {
        width: '2px',
        height: '40px',
        background: '#A9EAEB',
        padding: '0',
        margin: '0 10px',
    },
    flareCanMainTextSmall: {
        margin: '0 20px',
        fontSize: '20px',
        lineHeight: 1,
    },
    flareCanSubTextSmall: {
        margin: '0',
        fontWeight: 300,
        fontSize: '16px',
        lineHeight: 1.5,

    },
    flareCanImgSmall: {
        width: '100%',
    },



    topGridContainer: {
        borderRadius: 4,
        marginTop: '5rem',
        padding: '16px',
        fontFamily: 'Noto Sans JP'
    },
    gridContainer: {
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column-reverse',
        },

    },


}));